import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Card, Container, Row } from 'react-bootstrap';
import {
  cropInfectionApi,
  getFormList,
  submitInfection
} from 'api/endpoints/CropInfection';
import { jwtDecode } from 'jwt-decode';
import { get, isEmpty } from 'lodash';
import useApi from 'hooks/useApi';
import DynamicForm from 'screens/common/dynamicForm';
import { toast } from 'react-toastify';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import FalconCardHeader from 'components/common/FalconCardHeader';
import { useNavigate } from 'react-router-dom';
import { formSubmissionToast } from 'helpers/utils';
import { getTenantFromToken } from 'utils/routeUtils';

function CropInfectionRuleCreation(props) {
  const tenant = getTenantFromToken();
  const tns_tenant = '03534add672340809e2c70314b1ce20e';
  const navigate = useNavigate();

  const [data, setData] = useState({});
  const getFormListApi = useApi(getFormList);
  const submitInfectionApi = useApi(submitInfection);

  useEffect(() => {
    getFormListApi.request(tns_tenant);
  }, [tns_tenant]);

  useEffect(() => {
    const data = get(getFormListApi, 'data.results', []);
    setData(data);
  }, [getFormListApi.data]);

  const handleFormSubmit = async formData => {
    try {
      const response = await cropInfectionApi.createRule(tns_tenant, formData);
      formSubmissionToast(response, toast, 'Rule');
      navigate(`/${tenant}/cropInfection/rules/report`);
    } catch (err) {
      formSubmissionToast(err, toast, 'Rule');
    }
  };

  const header = (
    <div className="d-flex align-items-center">
      <div
        className="me-2 my-auto theme-control-toggle"
        onClick={() => navigate(`/${tenant}/cropInfection/rules/report`)}
      >
        <div className="theme-control-toggle-label">
          <FontAwesomeIcon icon={faArrowLeft} className="fs-0" />
        </div>
      </div>
      <span>Create New Rule</span>
    </div>
  );

  return (
    <Container>
      <Row>
        <Card className="mb-3">
          <Card.Header>
            <FalconCardHeader
              title={header}
              className="ps-lg-4"
              titleTag="h5"
              titleClass="mb-0"
              light
            />
          </Card.Header>
          <Card.Body>
            {!isEmpty(data) && (
              <DynamicForm
                data={data}
                header={true}
                onSubmit={handleFormSubmit}
              />
            )}
          </Card.Body>
        </Card>
      </Row>
    </Container>
  );
}

CropInfectionRuleCreation.propTypes = {};

export default CropInfectionRuleCreation;
